module.exports = "<md-dialog flex=40> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=col-md-12> <img class=\"col-md-12 m-v-sm no-padding\" class=img-responsive ng-src={{url}}> </div> </md-dialog-content> </md-dialog> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/partials/review/modals/viewFile.html
// module id = 714
// module chunks = 0